import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Chip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TablePagination,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Stack,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import configServ from "../services/config";
import CardHeadMenu from "../Components/Card/CardHeadMenu/CardHeadMenu";
import { useSelector } from "react-redux";

const LeaveTable = ({handleEdit, ischange}) => {
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [open, setOpen] = useState(false);
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { company_id, is_admin, user_id } = useSelector(
    (state) => state.GlobalVariables,
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  // ✅ SAFE truncate
  const truncateText = (text, limit = 20) => {
    if (!text) return "-";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const fetchLeaveData = async (currentPage, limit) => {
    setLoading(true);
    try {
      const response = await configServ.getLeaves({
        company_id: company_id,
        page: currentPage + 1,
        per_page: limit,
        isAdmin: is_admin, // ✅ FIX (small bug)
        employee_id: user_id,
      });

      if (response.status === 200) {
        setLeaveData(response.data.data || []);
        setTotal(response.data.total || 0);
      } else {
        setLeaveData([]);
        setTotal(0);
      }
    } catch (error) {
      console.log(error);
      setLeaveData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveData(page, rowsPerPage);
  }, [page, rowsPerPage, ischange]);

  const handleOpen = (leave) => {
    setSelectedLeave(leave);
    setOpen(true);
  };

  // const handleEdit = (row) => {
  //   console.log("Edit Data 👉", row);
  //   // 👉 yaha form me bhej sakte ho
  // };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
        return "error";
      default:
        return "default";
    }
  };

  return (
    <>
      <Box sx={{ width: "100%", p: 2 }}>
        {loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center", minHeight: 300 }}
          >
            <CircularProgress />
          </Box>
        ) : leaveData.length === 0 ? (
          <Paper sx={{ p: 5, textAlign: "center" }}>
            <Typography>No Leave Data Found</Typography>
          </Paper>
        ) : (
          <>
            {/* ✅ TABLE */}
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#fff" }}>S.No</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Emp Name</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Leave Type</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Reason</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Duration</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Days</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                    <TableCell sx={{ color: "#fff" }}>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {leaveData.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                      <TableCell>{row.employee_name || "-"}</TableCell>

                      <TableCell>{row.leave_name || "-"}</TableCell>

                      <TableCell>
                        <Tooltip title={row.reason || "-"}>
                          <span>{truncateText(row.reason, 15)}</span>
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        {row.from_date || "-"} <br />
                        <small>to</small> <br />
                        {row.to_date || "-"}
                      </TableCell>

                      <TableCell>{row.total_days || 0}</TableCell>

                      <TableCell>
                        <Chip
                          label={row.status?.toUpperCase()}
                          color={getStatusColor(row.status)}
                          size="small"
                        />
                      </TableCell>

                      <TableCell>
                        <IconButton onClick={() => handleOpen(row)}>
                          <VisibilityIcon />
                        </IconButton>

                        <IconButton
                          onClick={() => handleEdit(row)}
                          color="secondary"
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* ✅ Pagination */}
            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
            />
          </>
        )}

        {/* ✅ Dialog */}
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
          <DialogTitle>Leave Details</DialogTitle>
          <DialogContent>
            {selectedLeave && (
              <>
                <Typography>
                  <b>Employee:</b> {selectedLeave.employee_name || "-"}
                </Typography>
                <Typography>
                  <b>Leave Type:</b> {selectedLeave.leave_name}
                </Typography>
                <Typography>
                  <b>Holiday Type:</b> {selectedLeave.holiday_title || "-"}
                </Typography>

                <Typography>
                  <b>Reason:</b> {selectedLeave.reason || "-"}
                </Typography>
                <Typography>
                  <b>From:</b> {selectedLeave.from_date}
                </Typography>
                <Typography>
                  <b>To:</b> {selectedLeave.to_date}
                </Typography>
                <Typography>
                  <b>Days:</b> {selectedLeave.total_days}
                </Typography>
                <Typography>
                  <b>Status:</b> {selectedLeave.status}
                </Typography>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default LeaveTable;
